export const ErrorText = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => {
  return (
    <div className={`pt-1 text-[12px] font-normal text-danger ${className}`}>
      {text}
    </div>
  );
};
